// @flow
import type { Element } from 'react';

import React from 'react';
import { FormGroup, Col, Row } from 'reactstrap';
import { FieldArray } from 'redux-form';
import {
  OCCUPANCY,
  OCCUPANCY_BY_STORY,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import FieldVisibilityToggle from '#components/pages/Models/Model/sections/support/forms/FieldVisibilityToggle/index.js';
import OccupancySelectMenu from './OccupancySelectMenu/index.jsx';
import renderOccupancyByStory from './renderOccupancyByStory/index.jsx';
import GridField from '#components/pages/Models/Model/sections/support/forms/GridField/index.jsx';

type Props = {|
  afterToggleOn: Function,
  defineByStory: boolean,
  form: string,
  supportDefineByStory: boolean,
|};

const OccupancyFieldset = ({
  afterToggleOn,
  defineByStory,
  form,
  supportDefineByStory,
}: Props): Element<typeof FormGroup> => (
  <FormGroup tag="fieldset">
    <legend>Occupancy</legend>
    <Row>
      {supportDefineByStory && (
        <Col>
          <FieldVisibilityToggle
            afterToggleOn={afterToggleOn}
            className="float-right define-occupancy-toggle"
            form={form}
            on={defineByStory}
            onFields={[OCCUPANCY_BY_STORY]}
            onText="Use simplified"
            offFields={[OCCUPANCY]}
            offText="Define by Story"
          />
        </Col>
      )}
    </Row>
    {defineByStory ? (
      <FieldArray form={form} name={OCCUPANCY_BY_STORY} component={renderOccupancyByStory} />
    ) : (
      <GridField
        name={OCCUPANCY}
        form={form}
        options={{
          columnSize: 5,
          labelText: 'Occupancy',
          ComponentType: OccupancySelectMenu,
          includeToolTip: true,
          includeFormGroup: true,
        }}
      />
    )}
  </FormGroup>
);

export default OccupancyFieldset;
